export default {"src":"__ASTRO_ASSET_IMAGE__D_zW$f6y__","width":960,"height":540,"format":"jpg"}